import { Component, ElementRef, Inject } from '@angular/core';

import { AppStartupService } from '@ridango/core';

import { BaseTicketComponent } from '../base-ticket/base-ticket.component';

@Component({
    selector: 'ridango-single-ticket',
    templateUrl: './single-ticket.component.html',
})
export class SingleTicketComponent extends BaseTicketComponent {
    constructor(@Inject('ENV') public env: any, public eRef: ElementRef, public appStartupService: AppStartupService) {
        super(env, eRef, appStartupService);
    }
}
